/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useEffect, useRef, Fragment} from "react";

import { AppContext } from "../components/AppProvider";
import { _CK, _API, _U } from "../modules/utils";

// UI
import { Loading } from "../components/UI/Loading";
import LoadingShimmer from "../components/UI/LoadingShimmer";
import { _CFG } from "../../../api/src/modules/config";
import useStore from "../modules/utils/store";

export default (props) => {
  const { auth, iam } = useContext(AppContext);
  const { saveAuth, saveIam } = useContext(AppContext);
  const { siteIdx, eventIdx, sessionIdx, passCode, au, type, targetType, preregIdx, redirectHash } = props;
  const { medigate, external } = props;
  const {name, mobile, email, smsAgree, emailAgree, remoteAddr, companyName} = props;
  const { siteInfo } = useStore();
  const hasStartedDirectLogin = useRef(false);
  const resolvedSiteIdx = siteIdx || siteInfo?.idx;

  const completeDirectLogin = (accessKey, sessionData) => {
    _CK.setAuth(accessKey);
    _CK.forceSetLogKey(sessionData.logKey);
    _CK.setConsoleCountView(0);
    saveIam(sessionData);
    saveAuth(accessKey);
    sessionStorage.removeItem('__directLoginPending');

    const nextHash =
      redirectHash ||
      (window.location.hash ? window.location.hash.split("?")[0] : "");

    if (nextHash) {
      const nextUrl = `${window.location.pathname}${nextHash}`;
      window.location.replace(nextUrl);
    }
  };

  const failDirectLogin = (message) => {
    sessionStorage.removeItem('__directLoginPending');

    if (message) {
      alert(message);
    }

    window.location.href = `/`;
  };

  const directLogin = async () => {
    if (medigate || external) {
      _CK.clearAuth();
      _CK.clearLogKey();
      _CK.setConsoleCountView(0);
      const req = {
        path: "/v1/client/medigate/access",
        data: {
          siteIdx: resolvedSiteIdx,
          eventIdx,
          sessionIdx,
          name,
          mobile,
          email,
          smsAgree,
          emailAgree,
          companyName,
          remoteAddr,
          targetType: medigate ? "MEDIGATE" : external ? "ICOD" : "",
          userAgent: _U.getUserAgent(),
        },
      };
      _API
        .post(req)
        .then((res) => {
          const { data } = res;
          if (res.status !== "SUCCESS" || !data || !data.accessKey) {
            alert("접근 권한이 없습니다.");
            window.location.href = `/`;
          } else {
            _CK.setAuth(data.accessKey);
            _CK.forceSetLogKey(data.data.logKey);
            _CK.setConsoleCountView(0);
            saveIam(data.data);
            saveAuth(data.accessKey);
          }
        })
        .catch((e) => {
          window.location.href = `/`;
        });
    } else if (eventIdx && passCode && !targetType) {
      _CK.clearAuth();
      _CK.clearLogKey();
      _CK.setConsoleCountView(0);
      const req = {
        path: "/v1/client/login",
        data: {
          passCode,
          siteIdx: resolvedSiteIdx,
          eventIdx,
          userAgent: _U.getUserAgent(),
          type: type,
        },
      };
      _API
        .post(req)
        .then((res) => {
          const { data } = res;
          if (res.status !== "SUCCESS") {
            alert("접근 권한이 없습니다.");
            window.location.href = `/`;
          } else {
            _CK.setAuth(data.accessKey);
            _CK.forceSetLogKey(data.data.logKey);
            _CK.setConsoleCountView(0);
            saveIam(data.data);
            saveAuth(data.accessKey);
          }
        })
        .catch((e) => {
          window.location.href = `/`;
        });
    } else if (eventIdx && targetType) {

      _CK.clearAuth();
      _CK.clearLogKey();
      _CK.setConsoleCountView(0);

      const req = {
        path: "/v1/client/external/guest/save",
        data: {
          siteIdx : siteIdx,
          eventIdx : eventIdx,
          sessionIdx : sessionIdx,
          preregIdx : preregIdx,
          passCode : passCode,
          targetType: targetType,
          userAgent: _U.getUserAgent(),
        },
      };

      await _API
        .post(req)
        .then((res) => {
          const { data } = res;

          if (res.status !== "SUCCESS" || !data || !data.accessKey) {
            alert("접근 권한이 없습니다.");
            window.location.href = `/`;
          } else {

            _CK.setAuth(data.accessKey);
            _CK.forceSetLogKey(data.data.logKey);
            _CK.setConsoleCountView(0);
            saveIam(data.data);
            saveAuth(data.accessKey);
          }
        })
        .catch((e) => {
          window.location.href = `/`;
        });


    } else if (eventIdx && au) {
      _CK.clearAuth();
      _CK.clearLogKey();
      _CK.setConsoleCountView(0);
      const req = {
        path: "/v1/client/adminLogin",
        isNoErrorNotify: true,
        data: {
          siteIdx: resolvedSiteIdx,
          eventIdx,
          userAgent: _U.getUserAgent(),
          email: props?.email,
          memType: props?.memType,
        },
        headers: {
          authorization: au,
          apiKey: _CFG.apiKey,
        },
      };
      _API
        .post(req)
        .then((res) => {
          const { data } = res;
          if (res.status !== "SUCCESS" || !data || !data.accessKey) {
            failDirectLogin("접근 권한이 없습니다.");
          } else {
            completeDirectLogin(data.accessKey, data.data);
          }
        })
        .catch((e) => {
          failDirectLogin("접근 권한이 없습니다.");
        });
    }
  };

  useEffect(() => {
    if (hasStartedDirectLogin.current) {
      return;
    }

    const requiresResolvedSiteIdx =
      medigate || external || (eventIdx && passCode && !targetType) || (eventIdx && au);

    if (requiresResolvedSiteIdx && !resolvedSiteIdx) {
      return;
    }

    hasStartedDirectLogin.current = true;
    directLogin();
  }, [au, eventIdx, external, medigate, passCode, resolvedSiteIdx, targetType]);

  return (
    <Fragment>
            <LoadingShimmer />
    </Fragment>
  );
};
